import { render, staticRenderFns } from "./modalTransportOrderCtReject.vue?vue&type=template&id=56b22e23&scoped=true"
import script from "./modalTransportOrderCtReject.vue?vue&type=script&lang=js"
export * from "./modalTransportOrderCtReject.vue?vue&type=script&lang=js"
import style0 from "./modalTransportOrderCtReject.vue?vue&type=style&index=0&id=56b22e23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b22e23",
  null
  
)

export default component.exports